import React, { Component, Fragment } from 'react'
import logo from '../logo.svg';
import '../App.css';
import TopBanner from '../components/topBanner/TopBanner';
import Services from '../components/services/services';
import TopNavigation from '../components/TopNavigation/header';
import Summary from '../components/Summary/Summary';
import Events from '../components/Events/Events';
import ResentProject from '../components/RecentProjects/ResentProject';
import Course from '../components/Course/course';
import Video from '../components/Video/Video';
import ClientReview from '../components/clientReview/clientReview';
import Footer from '../components/Footer/Footer';
import Culture from '../components/Culture/Culture';
import WorkFlow from '../components/WorkFlow/WorkFlow';


export class HomePage extends Component {

  componentDidMount(){
    window.scroll(0,0);
  }



  render() {
    return (
      <div>
        <Fragment>
             <TopNavigation></TopNavigation>
                  <TopBanner></TopBanner>
                  
                 
                 <TopNavigation></TopNavigation> 
                
                  
                  <ResentProject></ResentProject>
                  <Course></Course>
                  <Culture></Culture>
                  <Video></Video>
                  <WorkFlow></WorkFlow>
                  <ClientReview></ClientReview>
                  <Footer></Footer>
                
        </Fragment>
      </div>
    )
  }
}

export default HomePage
